import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import useAxios from '../../Hooks/useAxios';

/**
 * Component for displaying the top metric cards in the Reports view.
 * Currently in placeholder state.
 * * @component
 */

const parseISOString = (dateString) => {
    if (!dateString) return new Date();
    const [year, month, day] = dateString.split('-').map(Number);
    return new Date(year, month - 1, day);
};


class ProcessStatusQuantity{
    constructor(totalQuantity = 0, lateQuantity = 0, onTimeQuantity = 0)
    {
        this._TotalQuantity = totalQuantity;
        this._LateQuantity = lateQuantity;
        this._OnTimeQuantity = onTimeQuantity;
    }

    get totalQuantity()
    { return this._TotalQuantity;}

    get lateQuantity()
    { return this._LateQuantity;}

    get onTimeQuantity()
    { return this._OnTimeQuantity;}

    set totalQuantity(value)
    { this._TotalQuantity = value;}

    set lateQuantity(value)
    { this._LateQuantity = value;}

    set onTimeQuantity(value)
    { this._OnTimeQuantity = value;}
 }

 const processesQuantities = new ProcessStatusQuantity();

const getNumber9 = () => {
    return 9;
};


class ProcessMetric {
  constructor(id, startDate, endDate) {
    this.id = id; // número entero
    this.strStartDate = startDate;
    this.strEndDate = endDate;
    //this.startDate = new Date(startDate); // fecha inicio
    //this.endDate = new Date(endDate);     // fecha fin
  }

  // método que calcula días entre fechas
  getOnboardingTime() {
    const diffMs = this.endDate - this.startDate; // diferencia en milisegundos
    const diffDays = diffMs / (1000 * 60 * 60 * 24); // convertir a días
    return Math.floor(diffDays);
  }
}


//$$ card text
const text1 = "Processes on time/let";
 let activeProcesses = [];
 let lateProcessLabels = [];

//$$ Getting process from api
 const GetProcesses = (dataSubprocesses) => {

    let text1 = "";
    const { data, isLoading, error } = useAxios("processes")

    //Checking parameter
    if (dataSubprocesses == null)
    {
        return text1;
    }

    //$$ data is a process array
    if (data && Array.isArray(data)) {

        let iNumActiveProcesses = 0;
        let iNumLateProcesses = 0;
        const today = new Date();

        //console.log("activeProcesses:", activeProcesses);
        //console.log("data:", data);

       activeProcesses = [];
       lateProcessLabels = [];


       const dataSubP = [...dataSubprocesses]
         .sort((a, b) => a.label - b.label)
         .filter((obj, index, self) =>
           index === self.findIndex(o => o.label === obj.label)
         );

       //$$ for each filtered subprocess...
       dataSubP.forEach((SubPRow) => {

           //$$ ... we search its active process
           data.forEach((row) => {

                if ((row.statusId === 1 || row.statusId === 2) && row.id === SubPRow.label){

                    //$$ Creating new ProcessMetric and adding it to activeProcess array
                    activeProcesses.push(new ProcessMetric(row.id, row.startDate, row.endDate));

           //         const projectEndDate = parseISOString(row.endDate);
           //         if (projectEndDate < today) {
           //             iNumLateProcesses++ ;
           //         }
                }
           });

       });

       dataSubprocesses.forEach((SubPRow) => {

            if (!SubPRow.endDate) return;

            //$$ Subproceso sin resolver cuya fecha de fin ya ha pasado
            const isLate = (SubPRow.statusId !== 3)
                        && (parseISOString(SubPRow.endDate) < today);

            //$$ Guardamos el label del proceso solo si no estaba ya
            if (isLate && !lateProcessLabels.includes(SubPRow.label)) {
                lateProcessLabels.push(SubPRow.label);
            }

       });

           //$$
           iNumLateProcesses = lateProcessLabels.length;
           iNumActiveProcesses = activeProcesses.length;

           text1 = "OK Processes on time/let "


             if(iNumActiveProcesses > 0 && iNumActiveProcesses > 0)
                processesQuantities.totalQuantity = iNumActiveProcesses;
             else
                processesQuantities.totalQuantity = 0;

              if(iNumActiveProcesses > 0 && iNumLateProcesses > 0)
                 processesQuantities.lateQuantity = iNumLateProcesses;
              else
                 processesQuantities.lateQuantity = 0;

              if(iNumActiveProcesses > 0 && (iNumActiveProcesses - iNumLateProcesses) > 0)
                 processesQuantities.onTimeQuantity = iNumActiveProcesses - iNumLateProcesses;
              else
                 processesQuantities.onTimeQuantity = 0;



    }

    return { text1};
 }


const RMCActiveProcess = ({ data }) => {

  const { text1} = GetProcesses(data);
   const getCard1Text = () => text1;


  //$$ functions array
  const cardFunctions = [getCard1Text];

  //$$ Cards number 1 per function
  const cardNumber = cardFunctions.length;

  return (

  <div
        style={{
          display: 'grid',

          // This will change the width of the card dynamically for fixing the grid width
          gridTemplateColumns: `repeat(${cardNumber}, 1fr)`,

          gap: '16px'
        }}
      >

        { cardFunctions.map((fn,i) => (
          <Paper
            key={i}
            elevation={0}
            sx={{
              p: 2,
              border: '1px solid #ccc',
              display: 'flex',
              flexDirection: "column",
              //justifyContent: 'center',
              //alignItems: 'center',
              bgcolor: '#f9f9f9',
              borderRadius: 2,
              height: 120
            }}
          >

          <Typography
                            variant="h6"
                            sx={{ textAlign: "left"}}

                          >
                            Processes
                          </Typography>

            <Typography
                            variant="h100"
                            sx={{ textAlign: "left", mb: 1 }}

                          >
                            On time/Late
                          </Typography>


       <Box display="flex" alignItems="baseline" justifyContent="center" gap={1}>
         <Typography component="span" variant="h2" fontWeight= "bold">
           {processesQuantities.totalQuantity}
         </Typography>

         <Typography component="span" variant="h5" fontWeight= "bold" sx={{ color: 'green' }}>
           {processesQuantities.onTimeQuantity}
         </Typography>

         <Typography component="span" variant="h5" fontWeight= "bold">
           /
         </Typography>

         <Typography component="span" variant="h5" fontWeight= "bold" sx={{ color: 'red' }}>
           {processesQuantities.lateQuantity}
         </Typography>
       </Box>

          </Paper>
        ))}
      </div>


  );
};

//$$ exporting Active processes array to others cards components

export const getActiveProcesses = () => {
  return activeProcesses;
};
export default RMCActiveProcess;